import { IAssetLog } from '@models/AssetLog.model';
import { Icon as BlueIcon } from '@blueprintjs/core';
import { format } from 'date-fns';
import {
  Circle,
  GenericTag,
  IconWrapper,
  RowDiv,
  StatusValue,
  TextValues,
  TriggeredByContent,
  TriggeredByText,
  CommentDiv,
  ValueContainer,
} from '../../AssetHistory.styles';

interface IAssetHistoryValues {
  data: IAssetLog;
}

const AssetHistoryValues = ({ data }: IAssetHistoryValues) => {
  const compareStrings = (str1: string, str2: string) => {
    const str1Array = str1.toLocaleLowerCase().split(',');
    const str2Array = str2.toLocaleLowerCase().split(',');
    const filteredString = str1Array.filter(
      element => !str2Array.includes(element),
    );

    return filteredString.map(item => (
      <RowDiv>
        <GenericTag className="removed">{item}</GenericTag>
      </RowDiv>
    ));
  };

  const showDates = (dateNonFormated: string) => {
    const date = new Date(dateNonFormated);
    const formatedDate = format(date, 'MM/dd/yyyy');

    return formatedDate;
  };

  const valuesType = () => {
    if (data.eventName === 'Updated Equipment status')
      return (
        <RowDiv>
          <StatusValue className="oldValue">
            <Circle className="oldValue" />
            {data.oldValue}
          </StatusValue>

          <IconWrapper>
            <BlueIcon icon="arrow-right" color="#474d66" size={7} />
          </IconWrapper>

          <StatusValue value={data.newValue}>
            <Circle value={data.newValue} />
            {data.newValue}
          </StatusValue>
        </RowDiv>
      );

    if (data.eventName === 'Removed Tag')
      return <RowDiv>{compareStrings(data.oldValue, data.newValue)}</RowDiv>;

    if (data.eventName === 'Added Tag')
      return (
        <RowDiv>
          <GenericTag>{data.newValue}</GenericTag>
        </RowDiv>
      );

    if (data.eventName === 'Removed Assigned user')
      return (
        <TriggeredByContent className="removed">
          <TriggeredByText className="removed">{data.oldValue}</TriggeredByText>
        </TriggeredByContent>
      );

    if (data.eventName === 'Added Assigned user')
      return (
        <TriggeredByContent>
          <TriggeredByText>{data.newValue}</TriggeredByText>
        </TriggeredByContent>
      );

    if (data.eventName === 'Updated Assigned user')
      return (
        <RowDiv>
          <TriggeredByContent className="removed">
            <TriggeredByText className="removed">
              {data.oldValue}
            </TriggeredByText>
          </TriggeredByContent>

          <IconWrapper>
            <BlueIcon icon="arrow-right" color="#474d66" size={7} />
          </IconWrapper>

          <TriggeredByContent>
            <TriggeredByText>{data.newValue}</TriggeredByText>
          </TriggeredByContent>
        </RowDiv>
      );

    if (data.eventName.split(' ').includes('date'))
      return (
        <RowDiv>
          {data.oldValue && (
            <TextValues className="removed">
              &quot;{showDates(data.oldValue)}&quot;
            </TextValues>
          )}

          {data.oldValue && data.newValue && (
            <IconWrapper>
              <BlueIcon icon="arrow-right" color="#474d66" size={7} />
            </IconWrapper>
          )}

          {data.newValue && (
            <TextValues>&quot;{showDates(data.newValue)}&quot;</TextValues>
          )}
        </RowDiv>
      );

    if (data.eventType === 'Cloned') return <div />;

    if (
      data.eventType === 'Comment' ||
      data.eventName === 'Updated Status comment' ||
      data.eventName === 'Updated Description field'
    )
      return <CommentDiv dangerouslySetInnerHTML={{ __html: data.newValue }} />;
    return (
      <RowDiv>
        {data.oldValue && (
          <TextValues className="removed">
            &quot;{data.oldValue}&quot;
          </TextValues>
        )}

        {data.newValue && data.oldValue && (
          <IconWrapper>
            <BlueIcon icon="arrow-right" color="#474d66" size={7} />
          </IconWrapper>
        )}

        {data.newValue && <TextValues>&quot;{data.newValue}&quot;</TextValues>}
      </RowDiv>
    );
  };

  return <ValueContainer>{valuesType()}</ValueContainer>;
};

export { AssetHistoryValues };
